module.exports = __webpack_public_path__ + "static/media/failure.778b9918.gif";